import React from "react";
import { useTranslation } from "react-i18next";
import { Typography as MuiTypography, TypographyProps as MuiTypographyProps } from "@mui/material";

export interface TypographyProps extends MuiTypographyProps {
    text?: string | null | undefined;
    tx?: string;
    txOptions?: object;
}

export const Typography = (props: TypographyProps) => {
    const { tx, variant, color, txOptions, text, children, style, ...rest } = props;

    const { t } = useTranslation();

    // @ts-expect-error tx err
    const translated = tx && t(tx, txOptions);
    const content = translated || text || children;

    return (
        <MuiTypography color={color || "text.primary"} variant={variant} style={style} {...rest}>
            {content ?? ""}
        </MuiTypography>
    );
};
